import { ComponentPropsWithRef } from 'react';
import { cn } from '@/shared/lib/cn';
import { Icon } from '@/shared/ui/icon';
import { Layout } from '@/shared/ui/layout';
import { useModalContext } from './modal-context';
import './modal.scss';

type Props = ComponentPropsWithRef<typeof Layout>;
export const ModalCloseButton = ({ className, ...props }: Props) => {
    const { onClose } = useModalContext();

    return (
        <Layout
            element="button"
            type="button"
            className={cn('modal__close-button', className)}
            onClick={() => {
                onClose('close-btn');
            }}
            {...props}
        >
            <Icon name="close" />
        </Layout>
    );
};
